import { useVideoUI } from "@platform/store";
import { VideoMeetingIntroDialog } from "./VideoMeetingIntroDialog";
import { useBreakpoint } from "@core/hooks/useBreakpoint";
import type { MeetingDetails } from "@core/features/videoMeeting";
import { useLocalVideo, useMeetingManager } from "amazon-chime-sdk-component-library-react";

type Props = {
  meetingDetails: MeetingDetails;
};

export function VideoMeetingIntroDialogContainer({ meetingDetails }: Props) {
  const { openSidebar } = useVideoUI();
  const { isVideoEnabled } = useLocalVideo();
  const meetingManager = useMeetingManager();

  const isMdScreen = useBreakpoint("md");

  const handleClose = async () => {
    try {
      if (!isVideoEnabled) {
        await meetingManager.audioVideo?.stopVideoInput();
      }
    } catch {
      // ignore
    }

    // Handle sidebar state
    if (isMdScreen) {
      openSidebar("materials");
    }
  };

  return (
    <VideoMeetingIntroDialog meetingDetails={meetingDetails} onClose={handleClose} />
  );
}

export default VideoMeetingIntroDialogContainer;
